<template>
    <div class="root">
      <van-nav-bar title="套餐订购" @click-left="onClickLeft"  left-arrow></van-nav-bar>
      <div class="top-bg">
        <div>充值号：<span class="number">{{query.short_number?query.short_number:iccid}}</span></div>
        <div style="height: .8rem" v-if="stockInfo.kind == 1 && stockInfo.balance > 0">可用积分：<span class="number">{{stockInfo.balance}}</span></div>
      </div>
      <div class="package-list">
        <div class="package-list-item" :class="packageID==item.id ? 'active' : ''" v-for="(item,index) in packageList" :key="index" @click="checkPackage(item)">
          <div class="line-1">
            <div>{{item.title}}</div>
            <div>
              <van-icon v-if="packageID==item.id" name="arrow-down" color="#cdd3e0" size=".33rem"/>
              <van-icon v-else name="arrow-up" color="#cdd3e0" size=".33rem"/>
            </div>
          </div>
          <div class="line-2">
            <div>{{item.price}}元</div>
          </div>
          <div class="line-3" v-show="packageID==item.id"><div v-html="item.desc"></div>
            <div style="color: #ff2e2e;font-size: .32rem;font-weight: bold;text-align: center;margin-top: .4rem">有效期:{{one.startDate}}至{{one.endDate}}</div>
          </div>
        </div>
      </div>
      <div class="expireDate" v-if="packageID>0">有效期:{{one.startDate}}至{{one.endDate}}</div>

      <div v-if="stockInfo.kind == 1 && stockInfo.balance > 0"class="submit-bnt" @click="createOrder">
        积分抵扣<span style="color: #ff2e2e">{{integral}}</span>元，立即订购
      </div>
      <div v-else class="submit-bnt" @click="createOrder">立即订购</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                iccid:'',
                packageID:0,
                type:0,
                packageList:[],
                one:{},
                stockInfo:{},
                tips:[],
                operator:{},
                authRecharge:0,
                query:{},
                bulu:0
            };
        },
      computed:{
        integral(){
          if(!this.packageID) return '--'
          if(this.stockInfo.balance - this.one.price > 0){
            return (this.one.price - 0.01).toFixed(2)
          }else{
            return this.stockInfo.balance
          }
        }
      },
        watch:{
            /*type:function () {
                this.queryPackageList();
            }*/
        },
        methods: {
          queCardInfo(){
            this.$toast.loading({ forbidClick: true, duration:0})
            this.fetchData('/card/queryBulu',{iccid:this.iccid},(res)=>{
              this.$toast.clear();
              this.bulu = 1;
              if(res.code){
                this.$dialog.alert({
                  title: "提示",
                  message: res.msg,
                  confirmButtonText: '去补录',
                  showCancelButton: false
                }).then(()=>{
                  this.$router.push({name:'bulu',query:{iccid:this.iccid}})
                })
              }
            })
          },
            queryPackageList(){
                this.$toast.loading()
                this.fetchData('/package/getRechargePackage',{iccid:this.iccid,type:this.type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.packageList = res.data
                    }else{
                        this.$toast.fail(res.msg)
                        this.packageList=[]
                    }
                })
            },
            checkPackage(item){
                this.packageID = item.id
                this.one = item;
            },
            changeType(type){
                this.type = type;
                this.queryPackageList();
            },
            createOrder(){
              if(!this.one || !this.one.id){
                this.$toast.fail('请先选择套餐');
                return false;
              }
                if(this.authRecharge == 0){
                    this.$toast.fail('请实名后再充值,若已实名，请尝试刷新网页重试');
                    return false;
                }
                if(!this.stockInfo){
                  this.$toast.fail('网络错误，请稍后或刷新重试');
                  return false;
                }
                if(!this.bulu){
                  this.$toast.fail('网络错误，请稍后或刷新重试');
                  return false;
                }
                if(this.one.alertmsg && this.one.alertmsg.length > 1){
                    this.$dialog.confirm({
                        title: '提示',
                        message: this.one.alertmsg
                    }).then(() => {
                        if(this.stockInfo.kind==3) {
                            this.commitorderbalance()
                        }else {
                            this.commitorder()
                        }
                    }).catch(() => {
                        // on cancel
                    });
                }else{
                    if(this.stockInfo.kind==3) {
                        this.commitorderbalance()
                    }else {
                        this.commitorder()
                    }
                }
            },
            commitorder(){
                this.$dialog.confirm({
                    title:false,
                    message:this.iccid+"卡号是否办理"+this.one.title+"套餐，有效期为"+this.one.startDate+"到"+this.one.endDate+"，请点击确认进行办理"
                }).then(()=>{
                  this.commitorder1()
                })
            },
            commitorder1(){
                this.$toast.loading({ forbidClick: true, duration:0})
                this.fetchDataPost('/order/createOrder',{iccid:this.iccid,packageID:this.packageID,type:this.type,integral:this.integral},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', res.data,
                            (payresult)=>{
                                if(payresult.err_msg == "get_brand_wcpay_request:ok" ) {
                                    this.$toast.success('支付成功');
                                    if(res.url) {
                                      window.location.href = res.url
                                    }else{
                                      this.$router.push({name: 'home', query: {iccid: this.iccid}})
                                    }
                                }
                            }
                        );
                    }else{
                        if(res.url){
                          if(res.msg) {
                            this.$dialog.confirm({
                              title: "提示",
                              message: res.msg
                            }).then(() => {
                              // on confirm
                              let query = {}
                              if (res.data) {
                                query = res.data
                              }
                              query.cardno = this.iccid
                                sessionStorage.removeItem('token');
                              this.$router.push({path: res.url, query: query})
                            }).catch(() => {
                              // on cancel
                            })
                          }else{
                            this.$router.push({path: res.url, query: res.data})
                          }
                        }else {
                            if (res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1) {
                                this.$toast.fail('登录失效，请尝试重新进入查询')
                                sessionStorage.clear()
                            } else {
                              this.$dialog.alert({
                                title: '提示',
                                message: res.msg,
                              }).then(() => {

                              });

                            }
                        }
                    }
                })

            },
            commitorderbalance(){
              if(this.operator.lastOrderID > 0 ){
                this.$dialog.confirm({
                  title: '温馨提示',
                  message: '24小时内已办理此套餐，是否再次办理，点击确认进行办理',
                }).then((value) => {
                    this.summitorderCardBalance()
                }).catch(()=>{

                })
              }else{
                this.summitorderCardBalance()
              }

            },
          summitorderCardBalance(){
            this.$dialog.confirm({
              title: false,
                message:this.iccid+"卡号是否使用"+this.one.price+"积分，办理"+this.one.title+"套餐，有效期为"+this.one.startDate+"到"+this.one.endDate+"，请点击确认进行办理"
            }).then((value) => {
              this.summitorderCardBalance1()
            }).catch(()=>{

            })
          },
          summitorderCardBalance1(){
            this.$toast.loading({ forbidClick: true, duration:0})
            this.fetchDataPost('/order/createOrderbalance',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
              this.$toast.clear();
              if(res.code){
                this.$dialog.alert({
                  title: '提示',
                  message: res.msg,
                }).then(() => {
                  this.$router.push({name:'home'})
                });
              }else{
                this.$dialog.alert({
                  title: '提示',
                  message: res.msg,
                }).then(() => {

                });
                if(res.msg && res.msg.indexOf("积分") !== -1){
                  setTimeout(res=>{
                    this.rechargeBalance()
                  },1500)

                }
              }

            })
          },
            rechargeBalance(){
                this.$router.push({name:"cardBalance",query: {iccid:this.iccid}})
            },
            getStockInfo(){
                this.fetchData('/card/info',{iccid:this.iccid},(res)=>{
                    if(res.data.kind == 4) {
                        this.$router.push({name:'rechargebalancepackage',query:this.$route.query})
                    }else{
                      this.stockInfo = res.data
                      this.getCardOperator();
                      this.queryPackageList()
                      this.getTips()
                      this.queCardInfo()
                    }
                })
            },
            getTips(){
                this.fetchData('/card/tips',{iccid:this.iccid},(res)=>{
                    this.tips = res.data.split("\n")
                })
            },
            getCardOperator(){
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        if(this.operator.activeRule == 1){
                            this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                                if (!res.data.simAuthStatus) {
                                    this.$dialog.alert({
                                        title: '实名提示',
                                        message: '请先完成实名',
                                    }).then(() => {
                                        // on close
                                        window.location.href = this.operator.authUrl
                                    });
                                }else{
                                    this.authRecharge = 1
                                }
                            })
                        }else{
                            this.authRecharge = 1
                        }
                    }
                })
            }
        },
        created: function () {
            this.query = this.$route.query;
            this.iccid = this.query .iccid;
            this.type = this.query .type
            this.getStockInfo()
        }
    };
</script>
<style lang="scss" scoped>
.root{
  .expireDate{
    text-align: center;
    color: #ff2e2e;
    font-size: .24rem;
    position: fixed;
    width: 6.9rem;
    left: 0.3rem;
    margin: 0 auto;
    line-height: .7rem;
    font-size: .28rem;
    bottom: 1.2rem;
  }
  .top-bg{
    background: #fafafa;
    border-bottom-left-radius: .3rem;
    border-bottom-right-radius: .3rem;
    line-height: .52rem;
    font-size: .3rem;
    font-weight: bold;
    text-align: left;
    padding: .3rem 0 0 .3rem;
    .number{
      color: #0051fe;
      text-align: left;
    }
  }
  .submit-bnt{
    width: 6.9rem;
    left: .3rem;
    margin: 0 auto;
    height: .7rem;
    line-height: .7rem;
    text-align: center;
    color: #fff;
    background: #0353fe;
    font-size: .28rem;
    border-radius: .24rem;
    position: fixed;
    bottom: .6rem;
  }
  .package-list{
    margin:  0 auto;
    width: 6.9rem;
    padding-bottom: 1.8rem;
    .package-list-item{
      padding: .3rem;
      background: #fff;
      box-shadow: 0 0 .1rem #f2f6ff;
      border-radius: .3rem;
      margin-bottom: .16rem;
      .line-1{
        display: flex;
        :first-child{
          flex: 2;
          text-align: left;
          font-weight: bold;
          font-size: .3rem;
          color: #242424;
        }
        :last-child{
          flex: 1;
          text-align: right;
          font-size: .3rem;
        }
      }
      .line-2{
        display: flex;
        font-size: .26rem;
        line-height:.74rem;
        :first-child{
          flex: 2;
          text-align: left;
          color: #242424;
        }
        :last-child{
          flex: 1;
          text-align: right;
          color: #ffa34b;
        }
      }
      .line-3{
        color: #666666;
        font-size: .24rem;
        line-height: .38rem;
        letter-spacing: .02rem;
        border-top: 1px solid #f5f6f9;
        padding-top: .2rem;
      }
    }
    .package-list-item.active{
      background: #0353fe;
      .line-1{
        :first-child{
          color: #fff;
        }
        :last-child{
          flex: 1;
          text-align: right;
          font-size: .3rem;
        }
      }
      .line-2{
        display: flex;
        font-size: .26rem;
        line-height:.74rem;
        :first-child{
          flex: 2;
          text-align: left;
          color: #fff;
        }
        :last-child{
          flex: 1;
          text-align: right;
          color: #fff;
        }
      }
      .line-3{
        color: #fff;
        font-size: .24rem;
        line-height: .38rem;
        letter-spacing: .02rem;
        border-top: 1px solid #fff;
        padding-top: .2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recharge.vue